module.exports = __webpack_public_path__ + "static/media/player-up.f542e312.svg";